import styled from 'styled-components';

export const Container = styled.div`
  width: 1135px;
  display: flex;
  flex-direction: column;
`;
